var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowPrevious = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "#001E3C"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.853 19c-.13 0-.26-.05-.36-.15l-6.35-6.5a.5.5 0 0 1 0-.7l6.34-6.5c.19-.2.51-.2.71 0 .2.19.2.51 0 .71l-6 6.15 6.01 6.16c.19.2.19.51 0 .71-.1.1-.22.14-.35.14z"
})));
export { SvgArrowPrevious as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNTdhMTRjM2EwZTA0MjVmYTkxMzRlMTZjMGNlY2IzOTMuc3ZnIjs=";